import { lazy } from 'react';
import { Route } from 'lucide-react';
import type { DemoRegistryEntry } from './types';

/**
 * THE list of demos. Adding a demo is: create src/demos/<id>/, then add one entry here.
 * Nothing else in the shell changes.
 *
 * This file is the only place allowed to import from @demos/* (enforced by the boundary lint
 * rules in @viana-demos/config), and it does so lazily so demos stay code-split.
 */
export const DEMO_REGISTRY: DemoRegistryEntry[] = [
  {
    id: 'journeys',
    title: 'Journeys',
    blurb:
      'Live and replayed customer journeys over a store floorplan — zones, heatmaps, trails, ' +
      'flow and the KPIs that come with them.',
    icon: Route,
    Routes: lazy(() => import('@demos/journeys')),
  },
];

export function findDemo(id: string | undefined): DemoRegistryEntry | undefined {
  return DEMO_REGISTRY.find((demo) => demo.id === id);
}

export type { DemoRegistryEntry } from './types';
